var solumaxLoggerApp = angular
	.module('Solumax.LoggerPlugins', [])